import APIService from './apiservice';
import cookie from 'js-cookie';
import { API_CLIENT_ID, API_CLIENT_SECRET } from '../constants';

const grant_type = 'password';
const user_info = 'userInfo';
const user_modules = 'userModules';
const scope = '*';


class AuthService{
	
  async login(username, password) {
	  const data = await APIService.doRequest(`oauth/token`, 'POST', {
              username,
              password,
              grant_type,
              scope,
              client_id: API_CLIENT_ID,
              client_secret: API_CLIENT_SECRET
          }, null);
        
      if (data?.access_token) {
		    APIService.setToken(data.access_token);		  
      }
      
      return data;
  }

  async logout() {
	  try{
		  await APIService.doRequest(`api/v1/logout`, 'POST');
	  } catch (error){
		  
	  } finally {
		  APIService.handleLogout();
	  }
  }
  
  async getCurrentUser(){
	  let userInfo = APIService.getUserInfo();
	  const withAccessToken = APIService.getToken() ? true : false;
	  
	  if(userInfo === null && withAccessToken){
		  userInfo = await APIService.doRequest(`api/v1/auth-user-details`, 'GET');
		  APIService.setUserInfo(userInfo);
	  }
	  return userInfo;
  }
  
  async getCurrentUserModules(){
	  const withAccessToken = APIService.getToken() ? true : false;
	  if(withAccessToken){
      return await APIService.doRequest(`api/v1/auth-user-modules`, 'GET');
	  }
	  return [];
  }
  
  withAccessToken() {
	  return APIService.getToken() ? true : false;
  }

  getAccessToken() {
	  return APIService.getToken();
  }

  getUserInfo(){
    return APIService.getUserInfo();
  }

  async checkQRData(data) {
	  const userdata = await APIService.doRequest(`api/v1/check-user-data`, 'POST', data, null);
    return userdata;
  }

  async registerUser(data) {
	  const userdata = await APIService.doRequest(`api/v1/register-user-data`, 'POST', data, null);
    return userdata;
  }

  async getUserAvatar(){
	  const withAccessToken = APIService.getToken() ? true : false;
	  
	  if(withAccessToken){
		  return await APIService.fetchImage(`api/v1/services/my/avatar`, 'GET');		  
	  }

	  return null;
  }

  getUserModules(){
    return APIService.getUserModules();
  }
    
}

const authService = new AuthService();

export default authService;